import template from "./date-range-selector.html";
import moment from "moment";
import {
	orderBy,
	find,
	some
} from "lodash";
import { FEATURE_TYPES } from "../../constants";

// date-range-selector
export class Controller {
	constructor($scope, $stateParams, $logger) {
		this.$stateParams = $stateParams;
		this.$scope = $scope;
		this.$logger = $logger;
		this.format = "shortDate";
		this.altInputFormats = ["M!-d!-yyyy", "M!/d!/yyyy", "M!-d!-yy", "M!/d!/yy", "M!.d!.yyyy", "M!.d!.yy", "shortDate"];
		this.dateOptions = {
			formatYear: "yy",
			startingDay: 0,
			minDate: new Date(12 * 60 * 60 * 1000)
		};
		this.startPopupOpen = false;
		this.endPopupOpen = false;

		this.allMonths = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		];

		this.rangeData = {
			LMonth: {
				display: "Last 30 days",
				startDate: moment().subtract(30, "days"),
				endDate: moment()
			},
			CurWeek: {
				display: "This Week",
				range: "week"
			},
			CurMonth: {
				display: "This Month",
				range: "month"
			},
			CurYear: {
				display: "This Year",
				range: "year"
			},
			LYear: {
				display: "Last 12 months",
				startDate: moment().subtract(1, "years"),
				endDate: moment()
			},
			YearMonth: {
				display: "Year + Month"
			},
			Custom: {
				display: "Custom"
			}
		};
	}

	$onInit() {
		this.availableYears = [];
		let earliestYear = orderBy(
			this.form.Seasons.map((season) => {
				return moment(season.BeginInclusive).year();
			}),
			(year) => year,
			["asc"]
		)[0];
		const currentYear = moment().year();

		while(earliestYear <= currentYear) {
			this.availableYears.push(earliestYear);
			earliestYear++;
		}

		this.availableYears = orderBy(this.availableYears, (year) => year, ["desc"]);

		this.selectedYear = this.startModel ? moment(this.startModel).year() : this.availableYears[0];
		this.selectedMonth = this.allMonths[moment(this.startModel).month()];

		this.rangeOptions = Object.keys(this.rangeData).map((optionKey) => {
			if(Object.prototype.hasOwnProperty.call(this.rangeData, optionKey)) {
				let start, end;
				const thisRange = this.rangeData[optionKey];

				if(thisRange.range) {
					start = moment().startOf(thisRange.range);
					end = moment().endOf(thisRange.range);
				}

				const thisOption = {
					...thisRange,
					key: optionKey,
					startDate: start || thisRange.startDate || null,
					endDate: end || thisRange.endDate || null
				};
				return thisOption;
			}
		});

		const matchingOptions = this.rangeOptions.filter((option) => {
			return moment(option.startDate).isSame(this.startModel, "day") && moment(option.endDate).isSame(this.endModel, "day");
		});

		let matchingOption = matchingOptions[0];

		if(!matchingOption) {
			const startModelYear = moment(this.startModel).year();
			const endModelYear = moment(this.endModel).year();
			const startModelMonth = moment(this.startModel).month();
			const endModelMonth = moment(this.endModel).month();

			if(startModelYear === endModelYear && startModelMonth === endModelMonth && moment(this.startModel).date() === 1
				&& moment(this.endModel).date() === moment(this.endModel).endOf("month")
					.date()) {
				matchingOption = find(this.rangeOptions, (option) => option.key === "YearMonth");
			}
		}

		const overrideMatch = some(this.form.Features, (feature) => feature.Type == FEATURE_TYPES.dateRangeDefaultYearMonth);

		if(overrideMatch) {
			matchingOption = find(this.rangeOptions, (option) => option.key === "YearMonth");
		}

		const paramMatch = this.rangeOptions.filter((option) => {
			return moment(option.startDate).isSame(moment(this.$stateParams.start), "day") && moment(option.endDate).isSame(moment(this.$stateParams.end), "day");
		});

		this.currentRangeOption = paramMatch && paramMatch[0] || matchingOption || this.rangeOptions[this.rangeOptions.length - 1];
	}

	onDateUpdate() {
		if(moment(this.startModel) > moment(this.endModel)) {
			this.endModel = moment(this.startModel).toDate();
		}
		this.onDateChange(this.startModel, this.endModel);
	}

	onSelectorChange() {
		if(this.currentRangeOption.key === "YearMonth") {
			this.startModel = moment().year(this.selectedYear)
				.month(this.selectedMonth)
				.date(1)
				.toDate();
			this.endModel = moment().year(this.selectedYear)
				.month(this.selectedMonth)
				.date(1)
				.endOf("month")
				.toDate();
			this.onDateUpdate();
		}
		else if(this.currentRangeOption.key !== "Custom") {
			this.startModel = this.currentRangeOption.startDate.toDate();
			this.endModel = this.currentRangeOption.endDate.toDate();
			this.onDateUpdate();
		}
	}
}
export default angular
	.module("vesl.components.date-range-selector", [])
	.component("dateRangeSelector", {
		template,
		controller: Controller,
		bindings: {
			onDateChange: "<",
			startModel: "=",
			endModel: "=",
			nomenclature: "<",
			form: "<"
		}
	}).name;
